// The MM/AA mask only guarantees four digits and a slash — it happily accepts 13/40, 00/40 or a half-typed 12.
const CARD_VALIDITY_PATTERN = /^(0[1-9]|1[0-2])\/\d{2}$/;

export const isValidCardValidity = (validity: string | undefined): boolean =>
  CARD_VALIDITY_PATTERN.test(validity ?? '');
